import TranditionalRaffleWinnerCard from "./tranditionalRaffleWinnerCard.container";

export default TranditionalRaffleWinnerCard;
